import * as React from 'react';
import styled from 'styled-components';
import Box from '@mui/material/Box';
import '../../container/Box/Components/Box-Style.css'

import CommonTable from '../../container/Table/Components/CommonTable'

function CardTable($title, $header, $content, $imagecloud) {

  return (

    // <BoxContainer sx={CardWrapper}>
    //   <Box sx={TitleWrap} className="sub-title normal" variant="h7" dangerouslySetInnerHTML={{ __html: $title }}></Box>
    //   <CommonTable header={$header} content={$content} />
    // </BoxContainer>
    <BoxContainer sx={CardWrapper}>
      <Box sx={TitleWrap} className="sub-title normal" variant="h7" dangerouslySetInnerHTML={{ __html: $title }}></Box>
      <CommonTable header={$header} content={$content} />
      <Image src={$imagecloud}></Image>
    </BoxContainer>

  );
};

const CardWrapper = {
  marginBottom: "20px",
  marginTop: "20px",
  // padding: "20px",
  // border: "#ebebeb solid 1px",
  // background: "#FFFFFF",
  // boxShadow: "0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%)",
  // borderRadius: "4px",
}

const TitleWrap = {
  height: "70px",
  textAlign: "left",
}

const BoxContainer = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    padding: 20px; */}
    margin-bottom: 20px;
    margin-top: 20px;
`

const Image = styled.img`
  width: 100%;
`

export default CardTable;